import React from 'react';

const QuestionnaireTitle = () => (
  <div className="container">
    <div className="row margin-top-xl">
      <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 text-center">
        <div className="dialog dialog-bubble dialog-md horizontal-center">
          <h2 className="margin-no">這兩個標語哪個比較吸引妳？</h2>
        </div>
      </div>
    </div>
  </div>
);

export default QuestionnaireTitle;



// WEBPACK FOOTER //
// ./app/components/QuestionnaireTitle.js